// Shared alphabetical ordering for the user-facing pickers and catalogue lists.
//
// `numeric: true` keeps "Campus 2" ahead of "Campus 10" — same comparator the
// permissions catalogue already used, lifted here so every picker orders names
// identically instead of each screen inventing its own rule.
//
// Only for lists a human scans. Ranked lists (leaderboards), chronological
// feeds, priority/status orders and wizard steps are ordered deliberately and
// must not be run through these.

export const compareText = (a, b) =>
    (a ?? '').localeCompare(b ?? '', undefined, { numeric: true });

// Copy-then-sort, so callers never reorder a state array in place.
export const sortByText = (list, getText) =>
    [...(list ?? [])].sort((a, b) => compareText(getText(a), getText(b)));

// Every user row renders the name and falls back to the email, so sort on the
// same string the row actually shows — otherwise a nameless user appears to be
// in the wrong place.
export const userLabel = (u) => u?.name || u?.email || '';

export const sortUsers = (users) => sortByText(users, userLabel);
